module.exports = __webpack_public_path__ + "static/media/AuditionMagic_50x50_GIF_0.1sec.6765ea85.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AuditionMagic_50x50_GIF_0.1sec.gif
// module id = 1115
// module chunks = 0